import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { selectIsAuthenticated, userLogin } from 'redux/authSlice';
import Logo from '../../assets/images/logo.svg';
import HeadBg from '../../assets/images/head-bg.png';
import { FloatingLabel, Form, Spinner } from 'react-bootstrap';
import 'react-input-code/dist/index.css';
import '../../styles/login.css';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import { useEnterPinMutation, useLoginMutation, useResetPinMutation, useResetPinSendOtpMutation, useSendOtpMutation, useValidateOtpMutation, useValidatePinMutation } from 'api/authApi';
import { CreatePinModel, LoginModel, LoginResponseModel, ResetPinModel, SendOTPModel, ValidateOTPModel, ValidatePinModel } from 'model/auth-model';
import { showToastError } from 'components/toastify/ToastNotifications';
import ReactCodeInput from 'react-code-input';

type Props = {}



const AdminLogin = (props: Props) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState('login');
    const isAuthenticated = useSelector(selectIsAuthenticated);
    const [pin, setPin] = useState('');
    const [otp, setOtp] = useState('');
    const [confirmPin, setConfirmPin] = useState('');
    const [pass, setPass] = useState('password');
    const [loginValues, setLoginValues] = useState<LoginModel>({ email: '', password: '' });
    const [loginData, setLoginData] = useState<LoginResponseModel | null>(null);
    const [resendOtp, setResendOtp] = useState(false);
    const [loadingPin, setLoadingPin] = useState(false);

    useEffect(() => {
        confirmAuthectication();
    }, []);

    const confirmAuthectication = () => {
        if (isAuthenticated) {
            navigate(-1);
        }
    };

    const [login, data] = useLoginMutation();
    const [enterPin, enterPinResult] = useEnterPinMutation();
    const [validatePin, validatePinResult] = useValidatePinMutation();
    const [resetPinSendOtp, resetPinSendOtpResult] = useResetPinSendOtpMutation();
    const [resetPin, resetPinResult] = useResetPinMutation();
    const [sendOtp, sendOtpResult] = useSendOtpMutation();
    const [validateOtp, validateOtpResult] = useValidateOtpMutation();

    const handleInitiateLogin = async (e: any) => {
        e.preventDefault();
        try {
            setLoading(true); // Set loading state to true
            const response = await login(loginValues).unwrap();
            if ('data' in response) {
                // dispatch(userLogin(response?.data));
                // setActiveTab('first');
                // return navigate('/');
                setLoginData(response?.data);
                if (response?.data?.isPinSet) {
                    setActiveTab('enterPin');
                }
                else {
                    setActiveTab('createPin');
                }
            }
        } catch (error: any) {
            showToastError(error?.data?.ResponseMessage);
        } finally {
            setLoading(false); // Reset loading state to false after the mutation is complete
        }
    };

    const handleCreatePin = () => {
        setActiveTab('confirmPin');
    };

    const handleConfirmPin = async (e: any) => {
        e.preventDefault();
        if (pin === confirmPin) {
            try {
                setLoading(true); // Set loading state to true
                const model: CreatePinModel = {
                    userId: loginData?.userId || '',
                    pin: pin
                };
                const response = await enterPin(model).unwrap();
                if ('data' in response) {
                    setActiveTab('enterPin');
                }
            } catch (error: any) {
                showToastError(error?.data?.ResponseMessage);
            } finally {
                setLoading(false); // Reset loading state to false after the mutation is complete
                setPin('');
            }
        }
        else {
            showToastError('Pin does not match');
        }
    }

    const handleEnterPin = async (e: any) => {
        e.preventDefault();
        try {
            setLoadingPin(true); // Set loading state to true
            const model: ValidatePinModel = {
                userId: loginData?.userId || '',
                pin: pin
            };
            const response = await validatePin(model).unwrap();
            if ('data' in response) {
                handleSendOTP();
            }
        } catch (error: any) {
            showToastError(error?.data?.ResponseMessage);
        } finally {
            setLoadingPin(false);
            setPin('');
            setConfirmPin('');
        }
    };

    const handlePinResetSendOTP = async () => {
        try {
            setLoading(true); // Set loading state to true
            const model = {
                userId: loginData?.userId || '',
                phoneNumber: loginData?.phoneNumber || '',
            };
            const response = await resetPinSendOtp(model).unwrap();
            if ('data' in response) {
                setActiveTab('resetPin')
            }
        } catch (error: any) {
            showToastError(error?.data?.ResponseMessage);
        } finally {
            setLoading(false); // Reset loading state to false after the mutation is complete
            setPin('');
        }
    };

    const handleSendOTP = async () => {
        try {
            setLoading(true); // Set loading state to true
            const model: SendOTPModel = {
                "userId": loginData?.userId || '',
                "phoneNumber": loginData?.phoneNumber || '',
            };
            const response = await sendOtp(model).unwrap();
            if ('data' in response) {
                setActiveTab('enterOTP');
                //setMessage(`New OTP has been sent to {loginData?.phoneNumber}`)
            }
        } catch (error: any) {
            showToastError(error?.data?.ResponseMessage);
        } finally {
            setLoading(false); // Reset loading state to false after the mutation is complete
            setOtp('');
        }
    };

    const handleEnterOTP = async (e: any) => {
        e.preventDefault();
        try {
            setLoading(true); // Set loading state to true
            const model: ValidateOTPModel = {
                "userId": loginData?.userId || '',
                "phoneNumber": loginData?.phoneNumber || '',
                "otp": otp
            }
            const response = await validateOtp(model).unwrap();
            if ('data' in response) {
                dispatch(userLogin(response?.data));
                setActiveTab('first');
                return navigate('/');
            }
        } catch (error: any) {
            showToastError(error?.data?.ResponseMessage);
        } finally {
            setLoading(false); // Reset loading state to false after the mutation is complete
            setOtp('');
        }
    };

    const handleNewPinEnterOTP = async (e: any) => {
        e.preventDefault();
        try {
            setLoading(true); // Set loading state to true
            const model: ResetPinModel = {
                "userId": loginData?.userId || '',
                "phoneNumber": loginData?.phoneNumber || '',
                "newPin": pin,
                "otp": otp
            }
            const response = await resetPin(model).unwrap();
            if ('data' in response) {
                dispatch(userLogin(response?.data))
                setActiveTab('first');
                return navigate('/');
            }
        } catch (error: any) {
            showToastError(error?.data?.ResponseMessage);
        } finally {
            setLoading(false); // Reset loading state to false after the mutation is complete
            setPin('');
        }
    };

    const inputcodeprops = {
        inputStyle: {
            margin: '5px',
            paddingLeft: '27px',
            width: '70px',
            borderRadius: '3px',
            fontSize: '30px',
            height: '70px',
            border: 'none',
            backgroundColor: '#F2F2F2',
            borderBottom: '2px solid black'
        }
    }


    return (
        <main className='login-section'>
            <header><img src={Logo} /></header>
            <div className='row'>
                <div className='col-xl-4 col-lg-6 col-md-8 col-sm-12 bg-white p-0 m-auto rounded-4'>
                    {activeTab === 'login' && <div>
                        <img src={HeadBg} className='rounded-bottom-0 rounded-top-4' width="100%" />
                        <div className='py-5 px-4 mx-2'>
                            <h5 className='fw-bold letter-spacing-1'>Sign in to your JobPro Admin</h5>
                            <span className='font-size-sm dark-text lh-sm'>We are delighted to have you with us. Sign in using the form below to continue</span>
                            <Form onSubmit={handleInitiateLogin}>
                                <FloatingLabel controlId="floatingInput" label="Email address" className="float-input my-4" >
                                    <Form.Control type='email' onChange={(e) => setLoginValues({ ...loginValues, email: e.target.value })} placeholder='Email Address' className="mt-4 font-size-normal" />
                                </FloatingLabel>
                                <div className='my-4'>
                                    <FloatingLabel controlId="floatingInput" label="Password" className="float-input my-4" >
                                        <Form.Control type={pass} onChange={(e) => setLoginValues({ ...loginValues, password: e.target.value })} placeholder='Password' className="font-size-normal" />
                                    </FloatingLabel>
                                    <div className='w-25 position-relative float-end text-end px-4 pointer' style={{ marginTop: "-60px" }}>
                                        {pass === 'text' ? <AiOutlineEye size={25} onClick={() => setPass('password')} /> : <AiOutlineEyeInvisible size={25} onClick={() => setPass('text')} />}
                                    </div>
                                </div>
                                <div className='d-flex justify-content-between mb-3'>
                                    <Form.Check type="checkbox" id="rememberMe" label={<label htmlFor="rememberMe"> Remember me </label>} />
                                    <Link to='/auth/forgot-password' className='red-text '>Forgot Password?</Link>
                                </div>
                                <button disabled={loading} type='submit' className='w-100 btn-primary rounded-5'>Sign in {loading && <Spinner size='sm' />}</button>
                            </Form>
                        </div>
                    </div>}
                    {activeTab === 'createPin' && <div>
                        <img src={HeadBg} className='rounded-bottom-0 rounded-top-4' width="100%" />
                        <div className='py-5 px-4 mx-2'>
                            <h5 className='fw-bold letter-spacing-1'>Create a new PIN for your account</h5>
                            <span className='font-size-sm dark-text lh-sm'>For an added level of security, you need to create a PIN for your account</span>
                            <Form onSubmit={handleCreatePin}>
                                <div className='mx-auto text-center mt-4 mb-4'>
                                    <ReactCodeInput type='number' name='' {...inputcodeprops} value={pin} onChange={setPin} autoFocus={true} inputMode='numeric' fields={4} />
                                </div>
                                {/* <div className='inputCodeContainer'>
                                    <ReactInputCode
                                        value={pin}
                                        onChange={setPin}
                                        type="number"
                                        className="my-input-code"
                                        itemClassName="my-code-item mx-auto fs-3"
                                        nItems={4}
                                        autoFocus={true}
                                    />
                                </div> */}
                                <button disabled={loading} type='submit' className='w-100 btn-primary rounded-5'>Proceed {loading && <Spinner size='sm' />}</button>
                            </Form>
                        </div>
                    </div>}
                    {activeTab === 'resetPin' && <div>
                        <img src={HeadBg} className='rounded-bottom-0 rounded-top-4' width="100%" />
                        <div className='py-5 px-4 mx-2'>
                            <h5 className='fw-bold letter-spacing-1'>Reset your PIN</h5>
                            <span className='font-size-sm dark-text lh-sm'>Create a new PIN for your account</span>
                            <Form onSubmit={handleNewPinEnterOTP}>
                                <p className='fs-5 pt-2'>Enter new pin</p>
                                <div className='mx-auto text-center mt-2'>
                                    <ReactCodeInput type='password' name='' {...inputcodeprops} value={pin} onChange={setPin} autoFocus={true} inputMode='numeric' fields={4} />
                                </div>
                                <p className='fs-5 pt-4'>Enter otp</p>
                                <div className='mx-auto text-center mb-4'>
                                    <ReactCodeInput type='number' name='' {...inputcodeprops} value={otp} onChange={setOtp} autoFocus={true} inputMode='numeric' fields={4} />
                                </div>
                                {/* <div className='inputCodeContainer py-4'>
                                    <p className='fs-5'>Enter new pin</p>
                                    <ReactInputCode
                                        value={pin}
                                        onChange={setPin}
                                        type="number"
                                        className="my-input-code"
                                        itemClassName="my-code-item mx-auto fs-3"
                                        nItems={4}
                                        autoFocus={true}
                                    />
                                </div> */}
                                {/* <div className='inputCodeContainer pt-2'>
                                    <p className='fs-5'>Enter otp</p>
                                    <ReactInputCode
                                        value={otp}
                                        onChange={setOtp}
                                        type="number"
                                        className="my-input-code"
                                        itemClassName="my-code-item mx-auto fs-3"
                                        nItems={4}
                                        autoFocus={true}
                                    />
                                </div> */}
                                <button disabled={loading} type='submit' className='w-100 btn-primary rounded-5'>Proceed {loading && <Spinner size='sm' />}</button>
                            </Form>
                        </div>
                    </div>}
                    {activeTab === 'confirmPin' && <div>
                        <img src={HeadBg} className='rounded-bottom-0 rounded-top-4' width="100%" />
                        <div className='py-5 px-4 mx-2'>
                            <h5 className='fw-bold letter-spacing-1'>Confirm your new PIN</h5>
                            <span className='font-size-sm dark-text lh-sm'>For an added level of security, you need to create a PIN for your account</span>
                            <Form onSubmit={handleConfirmPin}>
                                <div className='mx-auto text-center mt-4 mb-4'>
                                    <ReactCodeInput type='number' name='' {...inputcodeprops} value={confirmPin} onChange={setConfirmPin} autoFocus={true} inputMode='numeric' fields={4} />
                                </div>
                                {/* <div className='inputCodeContainer'>
                                    <ReactInputCode
                                        value={confirmPin}
                                        onChange={setConfirmPin}
                                        type="number"
                                        className="my-input-code"
                                        itemClassName="my-code-item mx-auto fs-3"
                                        nItems={4}
                                        autoFocus={true}
                                    />
                                </div> */}
                                <button disabled={loading} type='submit' className='w-100 btn-primary rounded-5'>Proceed {loading && <Spinner size='sm' />}</button>
                            </Form>
                        </div>
                    </div>}
                    {activeTab === 'enterPin' && <div>
                        <img src={HeadBg} className='rounded-bottom-0 rounded-top-4' width="100%" />
                        <div className='py-5 px-4 mx-2'>
                            <h5 className='fw-bold letter-spacing-1'>Enter your PIN</h5>
                            <span className='font-size-sm dark-text lh-sm'>Just so we are sure its you, kindly enter the PIN associated with your account</span>
                            <Form onSubmit={handleEnterPin}>
                                <div className='mx-auto text-center mt-4 mb-4'>
                                    <ReactCodeInput type='password' name='' {...inputcodeprops} value={pin} onChange={setPin} autoFocus={true} inputMode='numeric' fields={4} />
                                </div>
                                {/* <div className='inputCodeContainer'>
                                    <ReactInputCode
                                        value={pin}
                                        onChange={setPin}
                                        type="password"
                                        className="my-input-code"
                                        itemClassName="my-code-item mx-auto fs-3"
                                        nItems={4}
                                        autoFocus={true}
                                    />
                                </div> */}
                                <p onClick={() => handlePinResetSendOTP()} className='pointer text-end px-4 primary-text' style={{ marginTop: '-20px', cursor: 'pointer' }}>Click here to reset your pin</p>
                                <button disabled={loadingPin} type='submit' className='w-100 btn-primary rounded-5'>Proceed {loadingPin && <Spinner size='sm' />}</button>
                            </Form>
                        </div>
                    </div>}
                    {activeTab === 'enterOTP' && <div>
                        <img src={HeadBg} className='rounded-bottom-0 rounded-top-4' width="100%" />
                        <div className='py-5 px-4 mx-2'>
                            <h5 className='fw-bold letter-spacing-1'>Enter OTP sent to your phone number</h5>
                            <span className='font-size-sm dark-text lh-sm'>{resendOtp && !loading ? <>New OTP has been sent to {loginData?.phoneNumber} and {loginData?.email}</> : <>An OTP has been sent to {loginData?.phoneNumber} and {loginData?.email}</>}</span>
                            <Form onSubmit={handleEnterOTP}>
                            <div className='mx-auto text-center mt-4 mb-4'>
                                    <ReactCodeInput type='number' name='' {...inputcodeprops} value={otp} onChange={setOtp} autoFocus={true} inputMode='numeric' fields={4} />
                                </div>
                                {/* <div className='inputCodeContainer'>
                                    <ReactInputCode
                                        value={otp}
                                        onChange={setOtp}
                                        type="number"
                                        className="my-input-code"
                                        itemClassName="my-code-item mx-auto fs-3"
                                        nItems={4}
                                        autoFocus={true}
                                    />
                                </div> */}
                                <p onClick={() => { setResendOtp(true); handleSendOTP() }} className='pointer text-end px-4 primary-text' style={{ marginTop: '-20px', cursor: 'pointer' }}>Click here to send a new otp </p>
                                <button disabled={loading} className='w-100 btn-primary rounded-5'>Sign in {loading && <Spinner size='sm' />}</button>
                            </Form>
                        </div>
                    </div>}
                </div>
            </div>
        </main>
    )
};

export default AdminLogin;
